import {
	CREATING_CUSTOMER,
	CUSTOMERS_FETCHED,
	CUSTOMER_CREATED,
	CUSTOMER_DELETED,
	CUSTOMER_DETAILS_FETCHED,
	CUSTOMER_MANAGEMENT_LIST_FETCHED,
	CUSTOMER_SELECTED,
	CUSTOMER_UPDATED,
	DELETING_CUSTOMER,
	FETCHING_CUSTOMERS,
	FETCHING_CUSTOMER_DETAILS,
	FETCHING_CUSTOMER_MANAGEMENT_LIST,
	FETCHING_SCIM_CONFIG,
	SCIM_CONFIG_FETCHED,
	SMTP_UPDATED,
	TOUR_STATUS_UPDATED,
	UPDATING_CUSTOMER,
	UPDATING_SMTP,
} from '../actions/';

const initState = {
	loading: true, response: null, list: [], currentCustomer: {},
	managementList: [], managementResponse: null, managementPagination: null, managementLoading: true,
};

export default function (state = initState, action) {
	switch (action.type) {
		case FETCHING_CUSTOMERS:
			return { ...state, response: null, list: [], loading: true };
		case CUSTOMERS_FETCHED: {
			const body = action.payload?.data;
			const isPaged = body && !Array.isArray(body);
			return {
				...state,
				response: action.payload,
				list: isPaged ? (body.data || []) : (body || []),
				pagination: isPaged ? { total: body.total, totalPages: body.totalPages, page: body.page } : null,
				loading: false,
			};
		}

		// Customers MANAGEMENT page's paginated table — deliberately separate from
		// list/pagination above, which ClientSelector/campaigns Dashboard/SMTP
		// Configure read from and expect to hold the full, unpaginated roster.
		case FETCHING_CUSTOMER_MANAGEMENT_LIST:
			return { ...state, managementResponse: null, managementLoading: true };
		case CUSTOMER_MANAGEMENT_LIST_FETCHED: {
			const body = action.payload?.data;
			const isPaged = body && !Array.isArray(body);
			return {
				...state,
				managementResponse: action.payload,
				managementList: isPaged ? (body.data || []) : (body || []),
				managementPagination: isPaged ? { total: body.total, totalPages: body.totalPages, page: body.page } : null,
				managementLoading: false,
			};
		}
		case CREATING_CUSTOMER:
			return { ...state, response: null, loading: true };
		case CUSTOMER_CREATED:
			return { ...state, response: action.payload, loading: false };
		case CUSTOMER_SELECTED:
			return { ...state, currentCustomer: action.payload };

		// Once the tour has been marked seen, reflect it locally so a Dashboard
		// remount within the same session never re-triggers it (the server write
		// is also in flight; this keeps Redux consistent regardless of ping races).
		case TOUR_STATUS_UPDATED:
			return { ...state, currentCustomer: { ...state.currentCustomer, tourStatus: false } };

		case FETCHING_CUSTOMER_DETAILS:
			return { ...state, customerResponse: null, fetching: true };
		case CUSTOMER_DETAILS_FETCHED:
			return { ...state, customerResponse: action.payload, fetching: false };

		case UPDATING_CUSTOMER:
			return { ...state, response: null, updating: true };
		case CUSTOMER_UPDATED:
			return { ...state, response: action.payload, updating: false };

		case DELETING_CUSTOMER:
			return { ...state, deleteResponse: null, deleting: true };
		case CUSTOMER_DELETED:
			return { ...state, deleteResponse: action.payload, deleting: false };

		case UPDATING_SMTP:
			return { ...state, smtpResponse: null, updating: true };
		case SMTP_UPDATED:
			return { ...state, smtpResponse: action.payload, updating: false };

		case FETCHING_SCIM_CONFIG:
			return { ...state, scimResponse: null, loading: true };
		case SCIM_CONFIG_FETCHED:
			return { ...state, scimResponse: action.payload, loading: false };
		default:
			return state;
	}
}
